import React, { useState, Fragment, useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import tracking from '@g4/g4-analytics';

import { Media } from '@g4/boneyard/lib/Media';
import Box from '@g4/boneyard/lib/Box';
import Layout from '@g4/boneyard/lib/Layout';

import SearchFormDataProvider from './HotelSearchForm/SearchFormDataProvider';
import SearchForm from './HotelSearchForm/SearchForm';
import ConditionalWrap from './ConditionalWrap';
import HeroImage from './HeroImage';
import { GA4_EVENTS } from '../utils/constants/trackingConstants';

const { FullWidth } = Layout;

const SearchFormWrapper = styled(Box)`
  ${props => props.theme.query.md} {
    margin-top: -215px;
  }
`;

const HotelSearchFormLandingPage = ({ theme }) => {
  const [destination, setDestination] = useState(false);

  useEffect(() => {
    tracking.setDataLayerVars({
      content_group: 'HotelSearchFormPage',
      qualified_user: '0',
    });
    tracking.trackPageView('', GA4_EVENTS.PAGE_VIEW);
  }, []);

  return (
    <Fragment>
      <FullWidth>
        <HeroImage destination={destination} />
      </FullWidth>
      <SearchFormDataProvider>
        {({ formData }) => {
          return (
            <Media>
              {mq => (
                <Box position="relative" zIndex={1}>
                  <ConditionalWrap
                    condition={mq.lte('sm')}
                    wrap={children => <FullWidth>{children}</FullWidth>}
                  >
                    <SearchFormWrapper
                      borderRadius={mq.lte('sm') ? undefined : 8}
                      backgroundColor={{
                        from: `${theme.colors.hob.blueSearchWidget.backgroundFrom} 70%`,
                        to:
                          theme.colors.hob.blueSearchWidget
                            .backgroundToGradient,
                      }}
                      {...(mq.lte('md')
                        ? { pt: 2, pr: 4, pb: 4, pl: 4 }
                        : { pt: 4, pr: 6, pb: 6, pl: 6 })}
                    >
                      <SearchForm
                        submitToPath="/hotel-booking/hotels"
                        {...formData}
                        themeColor={'blueSearchWidget'}
                        handleDestinationSelect={setDestination}
                      />
                    </SearchFormWrapper>
                  </ConditionalWrap>
                </Box>
              )}
            </Media>
          );
        }}
      </SearchFormDataProvider>
    </Fragment>
  );
};

HotelSearchFormLandingPage.propTypes = {
  theme: PropTypes.object.isRequired,
};

export default withTheme(HotelSearchFormLandingPage);
